// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"272":"733087f1","489":"f5c79070","555":"f8b63dab","591":"b4ea7c17","936":"af75a792"}[chunkId] + ".chunk.js";
};